var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmissionDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 60,
    viewBox: "0 0 47 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1997_8586)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1997_8586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1801 11.7466H38.7812C41.9945 11.7466 44.6261 14.7106 44.6261 18.3394V52.5222C44.6261 56.1787 42.0222 59.115 38.7812 59.115H7.22995C4.01665 59.115 1.38507 56.151 1.38507 52.5222V18.3394C1.38507 14.6829 3.98895 11.7466 7.22995 11.7466H11.1081",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9474 7.56392C28.9474 4.43373 26.3989 1.88525 23.2687 1.88525H22.7147C19.5845 1.88525 17.036 4.43373 17.036 7.56392C13.9058 7.56392 11.3851 10.0847 11.3851 13.2149V15.6526H34.5984V13.2149C34.5984 10.0847 32.0776 7.56392 28.9474 7.56392Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 46.8711H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 36.5664H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 26.2617H34.9861",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1997_8586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9834,
    height: 60,
    fill: "white",
    transform: "translate(0.508301)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1997_8586"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9834,
    height: 60,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmissionDone);
export default __webpack_public_path__ + "static/media/submission-done.ff305f5fa7023b8cd73fd3d938ece703.svg";
export { ForwardRef as ReactComponent };